/*
 * This file is generated by scripts/generate-ts-colors.ts DON'T MODIFY CONTENT HERE
 */

export enum Colors {
  border = '#d0d9dd',
  borderLight = '#e6f0f6',
  colorDarkest = '#24252d',
  colorLight = '#7c8498',
  colorLighter = '#dce2e5',
  colorPrimary = '#1999e3',
}
